module.exports = __webpack_public_path__ + "img/width-medium@2x.85f7b5b.jpg";